import { EgretVerticalNav } from 'egret'
import Scrollbar from 'react-perfect-scrollbar'
import { navigations } from '../../navigations'

const Sidenav = ({ children }) => {
  const faqTab = navigations.find((item) => item.path === '/grants/faq')
  const otherTabs = navigations.filter((item) => item.path !== '/grants/faq')

  return (
    <div>
      <Scrollbar
        options={{ suppressScrollX: true }}
        className='scrollable position-relative'
        style={{ height: 'calc(100vh - 70px)' }}
      >
        {children}
        <EgretVerticalNav navigation={otherTabs} />
      </Scrollbar>

      <div
        className='sticky-nav-wrapper'
        style={{
          position: 'sticky',
          bottom: 0,
          left: 0,
          right: 0,
          height: '60px',
          width: '100%',
          backgroundColor: '#FFF',
          borderTop: '1px solid #00000040',
          display: 'flex',
          alignItems: 'center',
          paddingTop: '13px',
          zIndex: 10
        }}
      >
        <div style={{ width: '100%' }}>
          <EgretVerticalNav navigation={[faqTab]} style={{ width: '100%' }} />
        </div>
      </div>
    </div>
  )
}

export default Sidenav
